<script>
export let free_agent;
export let is_active;


import MsgCard from 'components/elements/MsgCard.svelte';


</script>


<style>

</style>


<div class="modal" class:is-active={is_active}>

	<div class="modal-background"></div>

	<div class="modal-card">

		<!-- head -->
		<header class="modal-card-head">
			<p class="modal-card-title">{free_agent.player_first_name} {free_agent.player_last_name}</p>
			<button class="delete" aria-label="close" on:click={() => is_active = false}></button>
		</header>

		<div class="modal-card-body" style="border-top-left-radius: 0 !important; border-top-right-radius: 0 !important;">

			<MsgCard msg_show={true} msg_text={'Free agent contact information:'} msg_type={'error'} msg_forever={true} />

			<div class="field">

				<div class="control">

					<!-- label -->
					<label>
						Parent/Guardian Name
					</label>

					<input type="text" name="" disabled class="input is-fullwidth" value="{free_agent.parent_guardian_first_name} {free_agent.parent_guardian_last_name}">

				</div>

			</div>

			<div class="field">

				<div class="control">

					<!-- label -->
					<label>
						Parent/Guardian Email
					</label>

					<input type="text" name="" disabled class="input is-fullwidth" value="{free_agent.parent_guardian_email}">

				</div>

			</div>

			<div class="field">

				<div class="control">

					<!-- label -->
					<label>
						Parent/Guardian Phone
					</label>

					<input type="text" name="" disabled class="input is-fullwidth" value="{free_agent.parent_guardian_phone_number}">

				</div>

			</div>


			<br>


			<!-- input (disabled...) -->

		</div>

	</div>

</div>
